import { render, staticRenderFns } from "./recordwareList.vue?vue&type=template&id=0b31dc59&scoped=true&"
import script from "./recordwareList.vue?vue&type=script&lang=js&"
export * from "./recordwareList.vue?vue&type=script&lang=js&"
import style0 from "./recordwareList.vue?vue&type=style&index=0&id=0b31dc59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b31dc59",
  null
  
)

export default component.exports